<template>
  <div class="fragment">
    <template
            v-if="$store.getters.getPromoCode.length > 0 && $store.getters.getPromoCodeLoading !== true">
      <div class="site-table-wrap small-table"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <div class="admin-edit" @click="editTranslate([
            'promoCode_Id',
            'promoCode_Code',
            'common_manage',
          ])"></div>
        <table class="site-table" v-if="!isMobileFunc()">
          <thead>
          <tr>
            <th>{{ $t('promoCode_Id.localization_value.value') }}</th>
            <th>{{ $t('promoCode_Code.localization_value.value') }}</th>
            <th width="100%" class="hide-1400"></th>
            <th>{{ $t('common_manage.localization_value.value') }}</th>
          </tr>
          </thead>
          <tbody>

          <tr v-for="(item, index) in $store.getters.getPromoCode" :key="index">
            <td>
              #{{item.id}}
            </td>

            <td>
              {{item.code}}
            </td>
            <td class="hide-1400"></td>
            <td class="manage-row">
              <div class="table-right table-manage-list table-manage-list--small">

                <ManagerButton @reloadManagerBtn="$store.commit('setGlobalUpdateManagerButton', Math.random()) "
                               :key="$store.getters.getGlobalUpdateManagerButton">
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_edit.localization_value.value')"
                            :type="'edit'"
                            @click.native="changePromoCodePopup(true, item.id)"
                    />
                  </template>
                  <template slot="item">
                    <LinkButton
                            :value="$t('common_delete.localization_value.value')"
                            :type="'delete'"
                            @click.native="deleteItem(item.id)"
                    />
                  </template>
                </ManagerButton>
              </div>
            </td>
          </tr>
          </tbody>
        </table>

        <div class="table-card" v-if="isMobileFunc()">
          <div class="table-card__list">
            <div class="table-card__item"
                 v-for="(item, index) in $store.getters.getPromoCode"
                 :key="index"
            >
              <PromoCodeTableMobile
                      :item="item"
                      @changePromoCodePopup="changePromoCodePopup(true, item.id)"
                      @deleteItem="deleteItem(item.id)"
              />
            </div>
          </div>
        </div>

        <div class="table-bottom-btn">
          <div class="table-bottom-btn__inner">
            <ShowMore
                    v-if="$store.getters.getPromoCodeCommonList.next_page_url !== null && $store.getters.getPromoCode.length > 0"
                    @click.native="$emit('showMore')"
                    :count="$store.getters.getPromoCodeCommonList.total - $store.getters.getPromoCodeForPage * $store.getters.getPromoCodeCommonList.current_page < $store.getters.getPromoCodeForPage ?
                    $store.getters.getPromoCodeCommonList.total - $store.getters.getPromoCodeForPage * $store.getters.getPromoCodeCommonList.current_page :
                    $store.getters.getPromoCodeForPage"
            />
          </div>
        </div>

      </div>
    </template>

    <template
            v-if="$store.getters.getPromoCodeLoading === false && $store.getters.getPromoCode.length === 0">
      <NoResult
              :countFilterParams="countFilterParams"
              :title="$t('common_noDataYet.localization_value.value')"
              :titleWithFilter="$t('common_noResult.localization_value.value')"
              :text="$t('common_noDataYetTxt.localization_value.value')"
              :textWithFilter="$t('common_noResultSeems.localization_value.value')"
              @resetFilter="$emit('resetFilter')"
      />
    </template>

    <PromoCodePopup
            v-if="isModalPromoCodePopup"
            :itemId="itemId"
            :type="'update'"
            @reload="$emit('reload')"
            @close="changePromoCodePopup(false)"
    />
  </div>
</template>

<script>
  import ManagerButton from "../../../../../../UI/buttons/ManagerButton/ManagerButton";
  import LinkButton from "../../../../../../UI/buttons/LinkButton/LinkButton";
  import ShowMore from "../../../../../../coreComponents/Buttons/ShowMore/ShowMore";
  import {mixinDetictingMobile} from '../../../../../../../mixins/mobileFunctions'
  import PromoCodePopup from "../../../../popups/PromoCodePopup/PromoCodePopup";
  import NoResult from "../../../../../../coreComponents/NoResult/NoResult";
  import PromoCodeTableMobile from "./PromoCodeTableMobile/PromoCodeTableMobile";

  export default {
    name: "PromoCodeTable",
    components: {
      PromoCodeTableMobile,
      NoResult,
      ManagerButton,
      LinkButton,
      ShowMore,
      PromoCodePopup,
    },

    mixins: [mixinDetictingMobile],

    props: {
      countFilterParams: Number,
    },

    data() {
      return {
        itemId: -1,
        showFilter: false,
        isMobile: false,

        showContent: false,

        // isModalProductsToWarehouse: false,

        show1: false,
        show2: false,

        isModalPromoCodePopup: false,

      }
    },

    methods: {
      changePromoCodePopup(val, id = false) {
        if (id) {
          this.itemId = id
        }
        this.isModalPromoCodePopup = val

        if (!val) {
          this.itemId = -1
        }
      },


      deleteItem(id) {
        let text = {
          title: 'common_deleteConfirm',
          txt: '',
          yes: 'common_confirm',
          no: 'common_confirmNo'
        }

        let confirm = () => {
          this.$store.dispatch('deletePromoCode', id).then(response => {
            switch (this.getResponseStatus(response)) {
                /**
                 * Success
                 */
              case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {
                this.openNotify('success', 'common_notificationRecordDeleted')
                this.$emit('reload')
                break
              }
                /**
                 * Validation Error
                 */
              case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
                let errors = response.response.data.errors;
                this.notifyErrorHelper(errors)
                break
              }
                /**
                 * Undefined Error
                 */
              default: {
                this.openNotify('error', 'common_notificationUndefinedError')
              }
            }
          }).catch(error => this.createErrorLog(error))

          this.$store.commit('setConfirmDeletePopup', false)
          return true
        }

        this.deleteFunc(text, confirm)
      },

    }
  }
</script>

<style scoped lang="scss">
  .comment-row {
    overflow: hidden;
    text-overflow: ellipsis;
    width: 115px;
    position: relative;
    display: inline-block;
    white-space: nowrap;
  }

  @media (max-width: 1400px) {
    .comment-row {
      width: 100px;
    }
  }

  .table-manage-list .manager-btn {
    width: 200px;
  }

  @media (max-width: 1400px) {
    .table-manage-list .manager-btn {
      width: 100px;
    }

    .user-field-admin {
      flex-wrap: wrap;
      display: flex;
    }

    .hide-1400 {
      display: none;
    }
  }

  /*.site-table thead th:first-child,*/
  /*.site-table tbody td:first-child {*/
  /*padding-right: 0;*/
  /*}*/

  /*.site-table thead th:nth-child(2),*/
  /*.site-table tbody td:nth-child(2) {*/
  /*padding-left: 0;*/
  /*}*/

  /*.site-table thead th:last-child,*/
  /*.site-table tbody td:last-child {*/
  /*padding-right: 0;*/
  /*}*/

  .small-table th,
  .small-table td {
    white-space: nowrap;
  }

  .size-24 {
    width: 24px;
    height: 24px;
    margin-top: -2px;
  }


</style>
